import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import router from './router'
import store from './store/store'
import messages from './store/messages'
import Wsocket from './module/socket'
import BootstrapVue from 'bootstrap-vue'
import push from 'push.js'
import filters from './components/filters'
import VueChartkick from 'vue-chartkick'
import Highcharts from 'highcharts'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.prototype.$socket = new Wsocket()
Vue.prototype.$push = push

Vue.use(VueI18n)
Vue.use(VeeValidate)
Vue.use(BootstrapVue)
Vue.use(push)
Vue.use(VueChartkick, { adapter: Highcharts })

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBJOuzulOvveitkxW97BoPcW_3qToOXoZo',
    libraries: 'places' // necessary for places input
  }
})

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

Vue.use(filters)

new Vue({
  data () {
    return { langs: ['fr', 'en'] }
  },
  i18n,
  router,
  store,
  beforeMount () {
    this.$socket.init(this)
  },
  render: h => h(App)
}).$mount('#app')
